import { render, staticRenderFns } from "./DeleteOwnerCommittee.vue?vue&type=template&id=31ec1ee1&scoped=true"
import script from "./DeleteOwnerCommittee.vue?vue&type=script&lang=js"
export * from "./DeleteOwnerCommittee.vue?vue&type=script&lang=js"
import style0 from "./DeleteOwnerCommittee.vue?vue&type=style&index=0&id=31ec1ee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec1ee1",
  null
  
)

export default component.exports